import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type Widget } from '../../../../Widget.ts';
import { isTableColumnWidget } from '../columns/IsTableColumnWidget.tsx';

export function getTableWidgetColumnTitle(column: Widget) {
  if (!isTableColumnWidget(column)) return '';

  return <RichTextAdvancedRender hasCustomFont text={column.label} />;
}
